import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setCurrentProductId } from '../../store/userSlice';
import { resetProductId, setProductDetail } from '../../store/productSlice';
import { clearComplaintDetail, resetComplaintId, setComplaintDetail } from '../../store/complaintSlice';

export const useCustomerActions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customer = useSelector((state) => state.user);

  const [updateComplaintDialog, setUpdateComplaintDialog] = useState(false);
  const [viewComplaintDialog, setViewComplaintDialog] = useState(false);

  const handleEditProduct = (row) => {
    // console.log(row, "row in handleEditProduct");
    dispatch(resetProductId());
    dispatch(setProductDetail({
      title: "Edit Product",
      isEdit: true,
      productId: row.productId,
      productName: row.name,
      registrationChannel: row.registrationChannel,
      registrationFlow: row.registrationFlow,
      categoryObject: row.categoryObject,
      serialNo: row.serialNo,
      skuId: row.skuId,
      subCategoryObject: row.subCategoryObject,
      purchaseDate: row.purchaseDate,
      warrantyDurationInDays: row.warrantyDurationInDays,
    }));
    navigate(`/product/edit`);
  };

  const handleRaiseComplaint = (row) => {
    dispatch(resetComplaintId());
    dispatch(clearComplaintDetail());
    dispatch(setComplaintDetail({
      title: 'Register New Complaint',
      isEdit: false,
      customerId: customer.userId,
    }));
    dispatch(setCurrentProductId(row.productId));
    navigate(`/complaint/add`);
  };

  const handleViewComplaint = (row) => {
    // console.log(row, "row in handleViewComplaint");
    dispatch(resetComplaintId());
    dispatch(clearComplaintDetail());
    dispatch(setComplaintDetail({
      complaintId: row.id,
      customerId: customer.userId,
      customerName: row.customerName,
      email: row.customerEmail,
      contactNumber: row.customerContact,
      productName: row.productName,
      createdDate: row.createdDate,
      warrantyStatus: row.warrantyStatus,
      description: row.description,
      categoryObject: row.complaintCategoryObject,
      subCategoryObject: row.complaintSubCategoryObject,
      priorityObject: { value: row.priority, label: row.priority },
      complaintTitle: row.title,
      complaintDescription: row.description,
      complaintReferenceNumber: row.complaintReferenceNumber,
      productId: row.productId,
    }));
    setViewComplaintDialog(true);
  };

  const handleEditComplaint = (row) => {
    // console.log(row, "row in handleEditComplaint");
    dispatch(resetComplaintId());
    dispatch(clearComplaintDetail());
    dispatch(setComplaintDetail({
      complaintId: row.id,
      title: row.title,
      isEdit: true,
      serialNo: row.serialNo,
      customerId: customer.userId,
      customerName: row.customerName,
      email: row.customerEmail,
      contactNumber: row.customerContact,
      rawStatus: row.rawStatus,
      productName: row.productName,
      createdDate: row.createdDate,
      warrantyStatus: row.warrantyStatus,
      feedbackRating: row.feedbackRating,
      feedbackRemarks: row.feedbackRemarks,
      feedbackRequest: row.feedbackRequest,
      customerFeedback: row.customerFeedback,
      complaintSubCategory: row.complaintSubCategory,
      description: row.description,
      categoryObject: row.complaintCategoryObject,
      subCategoryObject: row.complaintSubCategoryObject,
      priorityObject: { value: row.priority, label: row.priority },
      complaintTitle: row.title,
      complaintDescription: row.description,
      complaintReferenceNumber: row.complaintReferenceNumber,
      productId: row.productId,
    }));
    setUpdateComplaintDialog(true);
  };

  const closeUpdateComplaintDialog = () => {
    dispatch(clearComplaintDetail());
    setUpdateComplaintDialog(false);
  };

  const closeViewComplaintDialog = () => {
    dispatch(clearComplaintDetail());
    setViewComplaintDialog(false);
  };

  return {
    updateComplaintDialog,
    viewComplaintDialog,
    handleEditProduct,
    handleRaiseComplaint,
    handleViewComplaint,
    handleEditComplaint,
    closeUpdateComplaintDialog,
    closeViewComplaintDialog,
    customer
  };
};